import React from 'react';
import { Routes, Route } from 'react-router-dom';

import UsefulList from './UsefulList';
import UsefulPage from './UsefulPage';

const Useful: React.FC = () => (
  <Routes>
    <Route path="/" element={<UsefulList />} />
    <Route path="/:slug" element={<UsefulPage />} />
  </Routes>
);

export default Useful;
